import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './Sagas/gameSaga';
import rootReducer from './Reducers';

// Single middleware: redux-saga drives the reactive game loop (combat,
// movement, events, quests). One-shot async flows (login, saveCharacter,
// updateUserCharacter) are now plain async functions in the action files —
// callers do `await loginUser(dispatch, ...)` directly. No thunk middleware.

const sagaMiddleware = createSagaMiddleware();

// Action ring buffer for crash diagnostics. ErrorBoundary reads
// window.__okoylDebug.actions to dump the last N actions before a crash.
// Cheap (~30 entries × strings), kept in prod intentionally.
const RING_SIZE = 30;
if (typeof window !== 'undefined') {
    window.__okoylDebug = window.__okoylDebug || { actions: [] };
}
const debugMiddleware = () => (next) => (action) => {
    if (typeof window !== 'undefined' && window.__okoylDebug) {
        const ring = window.__okoylDebug.actions;
        ring.push({ t: Date.now() % 100000, type: action?.type || '(unknown)' });
        if (ring.length > RING_SIZE) ring.shift();
    }
    return next(action);
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(debugMiddleware, sagaMiddleware))
);

sagaMiddleware.run(rootSaga);

export { store };
